export const getLockStatusText = (currentIndex, relockEventDateList) => {
  const status = relockEventDateList?.[currentIndex]?.requestedStatus;
  if (status === '') return 'Current Price';
  return status || '';
};

export const getWorseCaseIndex = (
  relockList,
  isZeroBasedPricing = false,
  rateDates: string[] = [],
  lockRequestDate?: string,
) => {
  let worsePriceIndex = 0;
  const indexList: number[] = [];
  if (relockList) {
    const worseCasePrice = relockList.reduce(
      (worst, p) =>
        isZeroBasedPricing
          ? p.price > worst
            ? p.price
            : worst
          : p.price < worst
          ? p.price
          : worst,
      relockList[0].price,
    );
    relockList.forEach((x, index) => {
      if (x.price === worseCasePrice) indexList.push(index);
    });

    if (indexList.length > 1 && lockRequestDate && rateDates.length > 0) {
      const lockRequestTime = new Date(lockRequestDate).getTime();
      let closestIndex = indexList[0];
      let closestDistance = Infinity;
      indexList.forEach((idx) => {
        const dist = Math.abs(
          new Date(rateDates[idx]).getTime() - lockRequestTime,
        );
        if (dist < closestDistance) {
          closestDistance = dist;
          closestIndex = idx;
        }
      });
      worsePriceIndex = closestIndex + 1;
    } else {
      worsePriceIndex = indexList[0] + 1;
    }
  }
  if (indexList.length === relockList?.length) {
    return false;
  }
  return worsePriceIndex;
};
